import React, { useState, useMemo, useRef, useCallback } from "react";
import { Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

import {
  useFetchLawyerList,
  usePublicTemplateList,
} from "../../api/hooks/public-templates";
import {
  PublicTemplatesFolderContainer,
  CatalogSearchBar,
} from "./TemplateCatalog";

import config from "../../config";
import { useTranslation } from "react-i18next";
import "../../scss/home.scss";

export function LawyersCatalog() {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState(null);
  const { data: lawyersData = {}, isLoading: isLoadingLawyers } =
    useFetchLawyerList();
  const handleSearchChange = useCallback((value) => setSearch(value), []);

  return (
    <div>
      <CatalogSearchBar
        onSearchChange={handleSearchChange}
        onCategoryChange={(value) => setCategory(value)}
      />
      <LawyersTemplatesSlider />
      <div style={{ minHeight: 3 * 300 }}>
        {isLoadingLawyers && (
          <div className="d-flex justify-content-center align-items-center">
            {" "}
            <Spinner className="ml-2" size="sm" />{" "}
          </div>
        )}
        {lawyersData?.data?.map?.((lawyer) => (
          <PublicTemplatesFolderContainer
            label={lawyer?.office?.name}
            logo={lawyer?.office?.logo}
            type="free|premium"
            user={lawyer._id}
            search={search}
            category={category?.value}
          />
        ))}
      </div>
    </div>
  );
}

function LawyersTemplatesSlider(params) {
  const [step, setStep] = useState(1);
  const LawyersTemplateSlide = useRef();
  const scroll = (scrollOffset) => {
    LawyersTemplateSlide.current.scrollLeft += scrollOffset;
  };
  const { data, isLoading } = usePublicTemplateList({
    onlyExternal: true,
    perPage: 6,
  });
  const { t } = useTranslation("common");

  return (
    <>
      <div className="LawyersTemplatesSlider--Header">
        <h2>{t("homePage.box4.2")}</h2>
      </div>
      <div className="LawyersTemplatesSlider--Parent" hidden={data?.total < 1}>
        <div
          className="control1"
          onClick={() => {
            if (step !== 1) {
              scroll(-1024);

              setStep(step - 1);
            }
          }}
        >
          <FontAwesomeIcon icon={faAngleLeft} color="#f37b33" size="2x" />
        </div>
        <div className="LawyersTemplatesSlider" ref={LawyersTemplateSlide}>
          {data?.data?.map((item) => (
            <TemplateSliderItem
              id={item._id}
              pic={item?.user?.office?.logo}
              bussinesName={item?.user?.office?.name}
              template={item?.name}
              category={item.categories?.[0]?.name}
            />
          ))}
        </div>
        <div className="Indicators">
          <div className={step === 1 ? "active" : "noActive"}></div>
          <div
            className={step === 2 ? "active" : "noActive"}
            hidden={data?.total < 3}
          ></div>
          <div
            className={step === 3 ? "active" : "noActive"}
            hidden={data?.total < 5}
          ></div>
        </div>
        <div
          className="control2"
          onClick={() => {
            if (step !== 3) {
              scroll(1024);

              setStep(step + 1);
            }
          }}
        >
          <FontAwesomeIcon icon={faAngleRight} color="#f37b33" size="2x" />
        </div>
      </div>
    </>
  );
}
function TemplateSliderItem({ pic, bussinesName, template, category, id }) {
  return (
    <Link className={"LawyersCatalogSliderItem"} to={`/templates/${id}/edit`}>
      <div className="picPreview">
        <div
          className="UploadedImage__dashboardSettings"
          style={{
            backgroundImage: `url("${pic}")`,
          }}
        ></div>
      </div>
      <div className="description2">
        <p className="bussinesName">
          {bussinesName?.length > 18
            ? bussinesName?.slice(0, 18) + "..."
            : bussinesName || "TExto de Prueba"}
        </p>
        <p className="name">
          {template?.length > 25
            ? template?.slice(0, 25) + "..."
            : template || "Contrato de Arrendamiento"}
        </p>
        <p className="category">{category || "Comerciales"}</p>
      </div>
    </Link>
  );
}
